// XRay'in `.iq-waves-effect` tıklama dalgası (eski `pluginInit.ripple`, jQuery'siz): tıklanan öğenin başına
// `span.ripple` eklenir, içerik kutusunun büyük kenarı çapında ve tıklama noktasında ortalı; animasyon temada
// (`.ripple`, `.rippleEffect`). Önceki dalga silinir.
function contentSize(element) {
  const style = window.getComputedStyle(element);
  let width = parseFloat(style.width) || 0;
  let height = parseFloat(style.height) || 0;
  if (style.boxSizing === 'border-box') {
    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
  }
  return { width, height };
}

function onClick(event) {
  const target = event.target instanceof Element ? event.target.closest('.iq-waves-effect') : null;
  if (!target) return;

  document.querySelectorAll('.ripple').forEach(ripple => ripple.remove());

  const rect = target.getBoundingClientRect();
  const posX = rect.left + window.scrollX;
  const posY = rect.top + window.scrollY;
  let { width, height } = contentSize(target);

  const ripple = document.createElement('span');
  ripple.className = 'ripple';
  target.prepend(ripple);

  if (width >= height) height = width;
  else width = height;

  ripple.style.width = width + 'px';
  ripple.style.height = height + 'px';
  ripple.style.top = (event.pageY - posY - height / 2) + 'px';
  ripple.style.left = (event.pageX - posX - width / 2) + 'px';
  ripple.classList.add('rippleEffect');
}

export function installRipple() {
  document.addEventListener('click', onClick);
}
